import { render, staticRenderFns } from "./ServiciosForm.vue?vue&type=template&id=227c2c70"
import script from "./ServiciosForm.vue?vue&type=script&lang=js"
export * from "./ServiciosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports